export default __webpack_public_path__ + "static/media/notebookEN.0f2b33f4.pdf";